(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('InvoicesCategorizedController', InvoicesCategorizedController);

    InvoicesCategorizedController.$inject = ['$scope', '$uibModal', 'InvoiceCustomService', 'ToastrService', 'MiscService', 'DateUtils'];

    function InvoicesCategorizedController ($scope, $uibModal, InvoiceCustomService, ToastrService, MiscService, DateUtils) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.openCalendar = openCalendar;
        vm.refresh = refresh;
        vm.onStartDateChange = onStartDateChange;
        vm.lastDayOfMonth = lastDayOfMonth;
        vm.resetForm = resetForm;
        vm.viewBreakdown = viewBreakDown;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        resetForm();

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadAll() {
            vm.categorizedInvoicesList = null;
            vm.statusText = "Fetching Categorized Invoices";
            InvoiceCustomService.returnCategorizedInvoices( DateUtils.convertLocalDateToServer(vm.startDate), DateUtils.convertLocalDateToServer(vm.endDate), vm.invType, vm.invStatus ).then(function( result ) {
                vm.categorizedInvoicesList = result.data;
                generateStatusText();
                if( vm.categorizedInvoicesList.yearInvoices !== undefined && vm.categorizedInvoicesList.yearInvoices.length === 0 ) {
                    vm.statusText = "Nothing fetched for Categorized Invoices with given date range";
                    ToastrService.info(vm.statusText, "Info");
                }
            }, function( error ) {
                if( error.status !== "404" ) {
                    ToastrService.error("Failed to fetch Invoices for Categorized Invoices", "Error");
                }
                vm.statusText = "Failed to fetch Invoices for Categorized Invoices";
            });
        }

        function refresh() {
            loadAll();
        }

        function resetForm() {
            vm.categorizedInvoicesList = null;
            vm.startDate = MiscService.generateStartDate( new Date() );
            vm.endDate = MiscService.generateEndDate( new Date() );
            vm.statusText = "Waiting for Command...";
            vm.invType = { purchase: true, sale: true, japan: true };
            vm.invStatus = { draft: true, approved: true, issued: true };
        }

        function onStartDateChange() {
            vm.endDate = MiscService.onStartDateChange( vm.startDate, vm.endDate );
        }

        function lastDayOfMonth() {
            vm.endDate = MiscService.generateLastDayOfMonth( vm.endDate );
        }

        function generateStatusText() {
            if( vm.startDate.getTime() === vm.endDate.getTime() ) {
                vm.statusText = "Showing Categorized Invoices for " + vm.startDate.toLocaleDateString("en-US");
            } else {
                vm.statusText = "Showing Categorized Invoices from " + vm.startDate.toLocaleDateString("en-US") + " to " + vm.endDate.toLocaleDateString("en-US");
            }
        }

        function viewBreakDown(categoryInvoice) {
            $uibModal.open({
                templateUrl: 'app/entities/invoice/dialogs/invoice-categorized-modal.html',
                controller: 'InvoiceCategorizedModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'app-modal-xl',
                resolve: {
                    entity: function() {
                        return categoryInvoice;
                    },
                    invType: function() {
                        return vm.invType;
                    },
                    invStatus: function() {
                        return vm.invStatus;
                    }
                }
            }).result.then();
        }
    }
})();
